exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QuestionComponent{margin:1rem 0}.QuestionComponent .question{color:rgba(0,0,0,.6);font-weight:700;font-size:1.3rem}", ""]);

// exports
